import { Component, ViewChild, Inject, OnDestroy } from '@angular/core';
import { OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { PaginationComponent } from '../shared/components/pagination/pagination.component';
import { SnackbarService } from "../shared/services/snackbar.service";
import { TreatmentApprovalService } from "./treatment-approval.service";
import { config } from "../../../config/index";
import { Subject, EMPTY, Subscription } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap } from 'rxjs/operators';
import { MatDialogRef, MatDialog } from '@angular/material';

import { SessionStorageService } from '../shared/services/session-storage.service';
import { TooltipService } from "../shared/services/tooltip.service";
import { RestrictOutsideScrollService } from "../shared/services/restrict-outside-scroll.service";

import { LtrErrorPopupComponent } from './../shared/components/ltr-error-popup/ltr-error-popup.component';

@Component({
    template: require('./treatment-approval.component.html'),
    styles: [require('./treatment-approval.component.less')],
    providers: [TreatmentApprovalService, SnackbarService, TooltipService],
    preserveWhitespaces: true
})

export class TreatmentApprovalComponent implements OnInit, OnDestroy {

    @ViewChild('notActivePracticePopup', {static: false}) notActivePracticePopup: any;
    @ViewChild("paginationId", {static: false}) setPagination: PaginationComponent;

    paginationItems: any;
    reqPageOffset: number = 0;
    reqItemsPerPage: number = 10;
    startCount: any;
    endCount: any;
    searchValue: string = '';
    master: any;
    selectedType: any;
    approvalListCount: any;
    treatmentApprovalList: any = [];
    selectedLocation: any;
    locationList: any = [];
    loading: boolean = true;
    currency: any;
    token: any;
    private accessToken = config.storage_key;
    sortParam: string = 'status';
    sortParams: any = ['status', 'expires_at'];
    sortParamsConfig: any = [];
    order: string = 'des';
    approvalId: any;
    notificationFlag: boolean = false;
    searchInputSub$: Subject<string> = new Subject<string>();
    limitInputSub$: Subject<string> = new Subject<string>();
    inputSubscription: Subscription;
    searchSubscription: Subscription;
    apiSubscriptions: Subscription;
    treatmentListapiSubscription: Subscription;

    dialogRefLtrErrorPopup: MatDialogRef<LtrErrorPopupComponent>;

    constructor(
        private _treatmentApprovalService: TreatmentApprovalService,
        private _router: Router,
        private _mdlSnackbarService: SnackbarService,
        private _activatedRoute: ActivatedRoute,
        private _sessionStorageService: SessionStorageService,
        private _tooltipService: TooltipService,
        private _restrictOutsideScrollService: RestrictOutsideScrollService,
        @Inject('utilService') private utilService: any,
        public dialog: MatDialog
    ) {
    }

    actionRequiredPendingCountUpdate = () => {
        this.utilService.updateActionRequiredListPendingCount.next({update: true});
    }

    // for sorting
    sort(param: any) {
        this.sortParam = param;
        if (this.sortParamsConfig[param].firstToggle) {
            this.sortParamsConfig[param].firstToggle = false;
        } else {
            this.sortParamsConfig[param].sortDescending = !this.sortParamsConfig[param].sortDescending;
        }
        for (let i = 0; i < this.sortParams.length; i++) {
            if (this.sortParams[i] !== param) {
                this.sortParamsConfig[this.sortParams[i]].firstToggle = true;
            }
        }
        this.sortParamsConfig[param].sortDescending ? this.order = 'des' : this.order = 'asc';
        this.getTreatmentApprovalList();
    }

    /**
    * Function to set items Per page value
    * @param  {any} limitValue
    * @param  {any} event
    */
    setLimit(limitValue: any, event: any) {
        if (limitValue !== null) {
            this.master = limitValue;
            this.setPagination.changedValue = true;
            this.setPagination.itemsPerPage = this.master;
            this.paginationItems = this.setPagination.emitterEvent();
            this.reqItemsPerPage = this.paginationItems.passedItems;
            this.reqPageOffset = this.paginationItems.reqOffset;
            this.getTreatmentApprovalList();
        }
    }

    /**
     * Function to set maximum items to be displayed in a page
     * @param  {any} selectedPageNumber
     */
    maxItemsPerPage(selectedPageNumber: any) {
        if (selectedPageNumber < this.approvalListCount) {
            this.selectedType = selectedPageNumber + 1;
            this.setLimit(this.selectedType, event)
        }
    }

    /**
     * Function to capture event emitted from pagination component
     * @param  {any} event
     */
    paginationComponentEvent(event: any) {
        this.reqItemsPerPage = event.itemsPerPage;
        this.reqPageOffset = event.offset;
        if (event.isClicked) {
            this.getTreatmentApprovalList();
        }
    }

    /**
     * Function to set minimum no of items to be displayed in apage
     * @param  {any} selectedPageNumber
     */
    minItemsPerPage(selectedPageNumber: any) {
        if (selectedPageNumber > 1) {
            this.selectedType = selectedPageNumber - 1;
            this.setLimit(this.selectedType, event)
        }
    }

    /* Search Function fro listing */
    searchEvent = () => {
        this.reqPageOffset = 0;
        this.getTreatmentApprovalList();
    }

    getTreatmentApprovalList = () => {
        this.loading = true;
        this.treatmentListapiSubscription?.unsubscribe();
        this.treatmentListapiSubscription = this._treatmentApprovalService.getTreatmentApprovalList(this.searchValue, this.reqItemsPerPage, this.reqPageOffset, this.selectedLocation, this.sortParam, this.order, this.approvalId)
            .subscribe((res: any) => {
                if (!res.data) {
                    this.treatmentApprovalList = [];
                } else {
                    this.treatmentApprovalList = res.data;
                    this.treatmentApprovalList.forEach((data : any) => {
                        data.currencySymbol = config.currency[data.currency];
                    });
                }

                this.approvalListCount = res.count;
                if (this.reqPageOffset >= 0) {
                    if (this.treatmentApprovalList.length !== 0) {
                        this.startCount = this.reqPageOffset + 1;
                        this.endCount = this.startCount + this.treatmentApprovalList.length - 1;
                    } else {
                        this.startCount = 0;
                        this.endCount = 0;
                    }
                }
                this.loading = false;
            },
            error => {
                this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                this.loading = false;
            });
    }

    approveTreatment(id: any, practiceActive: boolean) {
        if (practiceActive) {
            this.loading = true;
            this.apiSubscriptions = this._treatmentApprovalService.approveTreatment(id)
                .subscribe((res: any) => {
                    this.loading = false;
                    this._sessionStorageService.saveItem('approval_from_url', 'treatment-approval').then(
                        data => {
                            if (res.data.errorCode === 'ENVELOPE_DOES_NOT_EXIST') {
                                this._mdlSnackbarService.showSnackbar('ENVELOPE_DOES_NOT_EXIST', 'error');
                            } else {
                                window.location.href = res.data.url;
                            }
                        }
                    );
                },
                error => {
                    if (error?.error_code === 321) {
                        this.openLTRErrorPopup(id);
                    } else {
                        this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    }

                    this.loading = false;
                });
        } else {
            this.notActivePracticePopup.show();
        }
    }

    openLTRErrorPopup(planId: number) {
        this._restrictOutsideScrollService.hideBackgroundScroll();

        this.dialogRefLtrErrorPopup = this.dialog.open(LtrErrorPopupComponent, {
            disableClose: true,
            data: {
                planId: planId,
            },
        });

        this.dialogRefLtrErrorPopup.afterClosed().subscribe(result => {
            if (result === 'revived') {
                this.getTreatmentApprovalList();
                this.actionRequiredPendingCountUpdate();
            }
            this._restrictOutsideScrollService.showBackgroundScroll();
        });
    }

    initiate() {
        this.selectedType = 10;
        this.getTreatmentApprovalList();
        for (let i = 0; i < this.sortParams.length; i++) {
            let newConfig = {
                sortDescending: true,
                firstToggle: true
            }
            this.sortParamsConfig[this.sortParams[i]] = newConfig;
        }
    }

    ngOnInit() {
        this._activatedRoute.params.subscribe(params => {
            this.approvalId = params['id'];
            if (this.notificationFlag) {
                this.initiate();
            }
            this.notificationFlag = true;
        });
        this.initiate();
        this.inputSubscription = this.limitInputSub$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap(event => {
                this.setLimit(this.selectedType, event);
                return EMPTY;
            })
        ).subscribe();
        this.searchSubscription  = this.searchInputSub$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap(event => {
                this.searchEvent();
                return EMPTY;
            })
        ).subscribe();
    }

    ngOnDestroy() {
        this.notActivePracticePopup.close();
        this.dialogRefLtrErrorPopup?.close();
        this.apiSubscriptions?.unsubscribe();
        this.inputSubscription?.unsubscribe();
        this.searchSubscription?.unsubscribe(); 
        this.treatmentListapiSubscription?.unsubscribe();
    }
}
